module.exports = __webpack_public_path__ + "img/logo-hrd.666adda.webp";